// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__-z1Rw","head":"ProcedureTableInfo_head__wpDwE"};